import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bento from "@/components/Bento";
import Sides from "@/components/Sides";
import VsLegacy from "@/components/VsLegacy";
import LantixPro from "@/components/LantixPro";
import Investor from "@/components/Investor";
import FinalCTA from "@/components/FinalCTA";
import ParentCompany from "@/components/ParentCompany";
import Footer from "@/components/Footer";

function Landing() {
  return (
    <div className="relative min-h-screen bg-black text-[#f3f3f3] overflow-x-clip">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Bento />
        <Sides />
        <VsLegacy />
        <LantixPro />
        <Investor />
        <FinalCTA />
        <ParentCompany />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(10,6,18,0.92)",
            border: "1px solid rgba(140,82,255,0.35)",
            color: "#f3f3f3",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </BrowserRouter>
  );
}
